import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { bdQuerySchema } from './bd-query-schema';

export const bdFormSchema = bdQuerySchema.omit({ name: true, abbreviation: true, status: true }).extend({
  name: z.string().min(3),
  abbreviation: z.string(),
  status: statusFormSchema,
});

export type BdFormSchema = z.infer<typeof bdFormSchema>;
